import React, { FC } from 'react'
import { ProductPills } from '@moonpig/web-shared-products'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'

export const ProductPillsModule: FC<ProductModule> = props => {
  const [
    {
      product: { primaryProductPill, productPills },
    },
  ] = useProductContext()
  const hasProductPills = Boolean(primaryProductPill || productPills?.length)
  return hasProductPills ? (
    <ProductModuleSection {...props}>
      <ProductPills
        primaryProductPill={primaryProductPill}
        productPills={productPills}
      />
    </ProductModuleSection>
  ) : null
}
